import { PencilIcon } from '@heroicons/react/24/outline';
import { Button, Input, Switch } from '@nextui-org/react';
import React from 'react';

import { ModernModal } from '@portal/components/common/ModernModal.ui';

interface EditUserModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  formData: {
    username: string;
    password: string;
    is_active: boolean;
    is_admin: boolean;
  };
  onFormDataChange: (data: { username: string; password: string; is_active: boolean; is_admin: boolean }) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const EditUserModal: React.FC<EditUserModalProps> = ({
  isOpen,
  onOpenChange,
  formData,
  onFormDataChange,
  onSubmit,
  isLoading,
}) => {
  const icon = <PencilIcon className='h-4 w-4' />;

  const footer = (
    <>
      <Button color='danger' variant='light' onPress={onOpenChange} disabled={isLoading}>
        Cancel
      </Button>
      <Button color='primary' onPress={onSubmit} isLoading={isLoading}>
        Update User
      </Button>
    </>
  );

  return (
    <ModernModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title='Edit User'
      subtitle='Update user account details'
      icon={icon}
      size='md'
      footer={footer}
    >
      <div className='flex flex-col gap-4'>
        <Input
          label='Username'
          placeholder='Enter username'
          value={formData.username}
          onValueChange={value => onFormDataChange({ ...formData, username: value })}
          isRequired
        />
        <div className='flex gap-4'>
          <Switch
            isSelected={formData.is_active}
            onValueChange={value => onFormDataChange({ ...formData, is_active: value })}
          >
            Active
          </Switch>
          <Switch
            isSelected={formData.is_admin}
            onValueChange={value => onFormDataChange({ ...formData, is_admin: value })}
          >
            Admin
          </Switch>
        </div>
      </div>
    </ModernModal>
  );
};
